import "./Item.scss";
import { Link } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";

export default function Item(props) {
  // 1) Нормалізуємо фасування:
  // - якщо є props.packings — беремо його
  // - якщо нема — збираємо зі старих unitFirst..unitFourth/priceFirst..priceFourth
  const packings = useMemo(() => {
    const fromArray = Array.isArray(props.packings) ? props.packings : null;

    const legacy = [
      { unit: props.unitFirst, price: props.priceFirst },
      { unit: props.unitSecond, price: props.priceSecond },
      { unit: props.unitThird, price: props.priceThird },
      { unit: props.unitFourth, price: props.priceFourth },
    ];

    const result = (fromArray ?? legacy)
      .filter(p => p && p.unit && p.price); // <-- прибираємо порожні

    return result;
  }, [props.packings, props.unitFirst, props.unitSecond, props.unitThird, props.unitFourth, props.priceFirst, props.priceSecond, props.priceThird, props.priceFourth]);

  // 2) Активна вкладка — індекс у packings (0..n-1)
  const [activeIdx, setActiveIdx] = useState(0);

  // якщо packings змінився і активний індекс “вилетів” — повертаємось на 0
  useEffect(() => {
    if (activeIdx > packings.length - 1) setActiveIdx(0);
  }, [packings.length, activeIdx]);

  const rootClass =
    "item" +
    (props.isNew ? " item--new" : "") +
    (props.InStock ? " item--stock" : "");

  return (
    <div className={rootClass}>
      <div className="item__row">
        <div className="item__title">
          <Link to={props.inside}>
            <span className="title">{props.title}</span>
          </Link>

          {props.isNew && <span className="item__new-arr">НОВИНКА!</span>}
        </div>

        <div className="item__wrapper">
          {props.imgUrl}

          <div className="item__center">
            <div className="item__block">
              <div className="itemCard__logo">{props.imgLogo}</div>
              <span className="item__factory-text">
                Виробник: <span className="item__factory-name">{props.producer}</span>
              </span>
            </div>

            <div className="item__zone">
              <div className="item__packing">
                <span className="item__packing-text">Фасування:</span>

                <div className="item__packing-position">
                  <div className="itemCard__capacity-tabs">
                    {packings.map((p, idx) => (
                      <button
                        key={`${props.id || props.title}-u-${idx}`}
                        className={idx === activeIdx ? "itemCard__cap-tabs active-itemCard__cap-tabs" : "itemCard__cap-tabs"}
                        onClick={() => setActiveIdx(idx)}
                        type="button"
                      >
                        {p.unit}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div className="item__price">
                <div className="price__charts">
                  <span className="price__item">Роздрібна ціна</span>
                </div>

                <div className="price itemCard__capacity-tabs-active">
                  {/* показуємо тільки активну ціну */}
                  <div className="capacity active-capacity">
                    {packings[activeIdx]?.price || ""}
                  </div>
                </div>

                <div className={"item__stock " + (props.InStock ? "item__stock--new" : "")}>
                  {props.InStock ? (
                    <span className="item__stock-arr">в наявності</span>
                  ) : (
                    <span className="item__stock-road">Уточнюйте наявність</span>
                  )}
                </div>
              </div>
            </div>

            <div className="item__suborder">
              <div className="item__order">{props.link}</div>
              <Link to={props.inside}>
                <p className="item__desc">Детальніше</p>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}